import { Link } from 'react-router-dom';
import { ChevronRight, ChevronLeft } from 'lucide-react';
import { ProductCard } from './ProductCard';

export const ProductCarousel = ({ id, icon: Icon, subtitle, title, products, scrollRef, viewAllHref, viewAllLabel, bg = 'bg-[#F7F7EB]' }) => {
  if (!products.length) return null;
  return (
    <section className={`py-20 px-6 md:px-12 lg:px-24 ${bg}`} data-testid={`${id}-section`}>
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-end mb-10">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <Icon className="w-4 h-4 text-[#DEA193]" />
              <p className="text-sm uppercase tracking-[0.2em] text-[#DEA193]">{subtitle}</p>
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-[#000]">{title}</h2>
          </div>
          <div className="flex items-center gap-2">
            <div className="hidden md:flex items-center gap-2">
              <button
                onClick={() => scrollRef.current?.scrollBy({ left: -320, behavior: 'smooth' })}
                className="w-10 h-10 border border-[#E5D8D0] flex items-center justify-center hover:border-[#DEA193] transition-colors bg-white"
                data-testid={`${id}-scroll-left`}
                aria-label="Scroll left"
              >
                <ChevronLeft className="w-5 h-5 text-[#000]" />
              </button>
              <button
                onClick={() => scrollRef.current?.scrollBy({ left: 320, behavior: 'smooth' })}
                className="w-10 h-10 border border-[#E5D8D0] flex items-center justify-center hover:border-[#DEA193] transition-colors bg-white"
                data-testid={`${id}-scroll-right`}
                aria-label="Scroll right"
              >
                <ChevronRight className="w-5 h-5 text-[#000]" />
              </button>
            </div>
            <Link to={viewAllHref} className="hidden md:flex items-center gap-2 ml-4 text-sm uppercase tracking-[0.15em] text-[#000] hover:text-[#DEA193] transition-colors" data-testid={`${id}-view-all`}>
              {viewAllLabel} <ChevronRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
        <div
          ref={scrollRef}
          className="flex gap-5 overflow-x-auto snap-x snap-mandatory pb-4 -mx-6 px-6 md:mx-0 md:px-0 scrollbar-hide"
          data-testid={`${id}-carousel`}
        >
          {products.map((product, idx) => (
            <div
              key={product.id}
              className="flex-shrink-0 w-[68vw] sm:w-[44vw] md:w-[calc(25%-15px)] snap-start"
              data-testid={`${id}-product-${idx}`}
            >
              <ProductCard product={product} />
            </div>
          ))}
        </div>
        <div className="text-center mt-8 md:hidden">
          <Link to={viewAllHref} className="inline-flex items-center gap-2 text-sm uppercase tracking-[0.15em] text-[#000] hover:text-[#DEA193] transition-colors" data-testid={`${id}-view-all-mobile`}>
            {viewAllLabel} <ChevronRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};
